import React, { useEffect, useRef, useState } from 'react'

import { Auth } from '../../amplify'
import parseUsername from '../utils/parseUsername'
import { useAuthScreenStyles } from './authScreenStyles'

const usernameFromQuery = () => new URLSearchParams(window.location.search).get('username') || ''

export default function CustomSignIn({ onForgotPassword, onRequireNewPassword, onSignedIn }) {
  const classes = useAuthScreenStyles()
  const [username, setUsername] = useState(usernameFromQuery)
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const mountedRef = useRef(true)

  useEffect(
    () => () => {
      mountedRef.current = false
    },
    [],
  )

  const handleSubmit = async event => {
    event.preventDefault()
    setLoading(true)
    setError('')

    const normalized = parseUsername(username || '').toLowerCase()

    try {
      const user = await Auth.signIn(normalized, password)
      if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
        onRequireNewPassword(user)
        return
      }
      onSignedIn()
    } catch (err) {
      if (err.code === 'PasswordResetRequiredException') {
        onForgotPassword(normalized)
        return
      }
      setError(err.message || 'Sign in failed.')
    } finally {
      if (mountedRef.current) {
        setLoading(false)
      }
    }
  }

  return (
    <div className={classes.page}>
      <div className={classes.card}>
        <img className={classes.logo} src="/assets/icons/blue-logo.svg" alt="Civic Champs" />
        <h3 className={classes.header}>Sign in to your account</h3>
        <form id="admin-dashboard-login-form" name="Admin Dashboard Login" onSubmit={handleSubmit}>
          <div className={classes.field}>
            <label className={classes.label} htmlFor="admin-sign-in-username">
              Username *
            </label>
            <input
              id="admin-sign-in-username"
              className={classes.input}
              name="username"
              placeholder="Enter your username"
              autoCapitalize="none"
              autoCorrect="off"
              spellCheck="false"
              autoComplete="username"
              autoFocus
              required
              value={username}
              onChange={e => setUsername(e.target.value)}
            />
          </div>
          <div className={classes.field}>
            <label className={classes.label} htmlFor="admin-sign-in-password">
              Password *
            </label>
            <input
              id="admin-sign-in-password"
              className={classes.input}
              name="password"
              type="password"
              placeholder="Enter your password"
              autoComplete="current-password"
              required
              value={password}
              onChange={e => setPassword(e.target.value)}
            />
            <p className={classes.hint}>
              Forget your password?{' '}
              <button type="button" className={classes.link} onClick={() => onForgotPassword(username)}>
                Reset password
              </button>
            </p>
          </div>
          {error && <p className={classes.error}>{error}</p>}
          <div className={classes.footer}>
            <button type="submit" className={classes.submit} disabled={loading}>
              Sign In
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}
